import { memo } from 'react';

import { ComponentContextProps } from '@/components';
import { Logo, LogoProps } from '@/components/core';
import { ValidationFilledIcon } from '@/components/icons';

export type ValidationFilledLogoProps = Omit<LogoProps, 'variant'> & Partial<ComponentContextProps>;

const IValidationFilledLogo = ({ className, ...rest }: ValidationFilledLogoProps) => {
  return (
    <Logo variant="primary" className={className} {...rest}>
      <ValidationFilledIcon />
    </Logo>
  );
};

export const ValidationFilledLogo = memo(IValidationFilledLogo) as typeof IValidationFilledLogo;
